import { useTranslation } from 'react-i18next';
import { FieldStatusIndicator } from '@/features/items/components/item-field-value/FieldStatusIndicator';
import { UnitInput } from './NumberInput';
import type { FinancialSaveState } from './types';

interface SavableUnitFieldProps {
  saveState: FinancialSaveState;
  value: number | null;
  unit: string;
  unitSide: 'left' | 'right';
  ariaLabel: string;
  decimals?: number;
  min?: number;
  max?: number;
  maxDecimals?: number;
  onCommit: (value: number | null) => void;
  onChange?: (value: number | null) => void;
  testId?: string;
}

export const SavableUnitField = ({ saveState, ...inputProps }: SavableUnitFieldProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-2">
        <FieldStatusIndicator
          isPending={saveState.status === 'pending'}
          isSuccess={saveState.status === 'success'}
        />
        <UnitInput {...inputProps} disabled={saveState.status === 'pending'} />
      </div>
      {saveState.status === 'error' && (
        <span role="alert" className="text-xs text-text-error">
          {saveState.message}
        </span>
      )}
      {saveState.status === 'success' && (
        <span role="status" className="sr-only">
          {t(($) => $.financials.panel.fieldSaved, { field: inputProps.ariaLabel })}
        </span>
      )}
    </div>
  );
};
